import { render, staticRenderFns } from "./SourceFieldManager.vue?vue&type=template&id=435c5dd6&scoped=true&"
import script from "./SourceFieldManager.vue?vue&type=script&lang=js&"
export * from "./SourceFieldManager.vue?vue&type=script&lang=js&"
import style0 from "./SourceFieldManager.vue?vue&type=style&index=0&id=435c5dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c5dd6",
  null
  
)

export default component.exports